module.exports = __webpack_public_path__ + "img/gsndc2762_2.fdf5c315.svg";